/**
 * Created by User on 29-Jul-17.
 */
import React from 'react';

const Icon = (props) => {
    return <i className={'fa fa-fw fa-'+props.name}/>;
};

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Nav/components/Icon/index.js